import { AnyAction } from 'redux'

export const ACTION_SHOW_ERROR = 'ACTION_SHOW_ERROR'
export const ACTION_GO_BACK = 'ACTION_GO_BACK'

export const actionShowError = (message?: string): AnyAction => ({
    type: ACTION_SHOW_ERROR,
    message,
})

export const actionGoBack = (): AnyAction => ({
    type: ACTION_GO_BACK,
})
